"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuthFlow } from "../../auth-flow-context";
import { AuthMethodId } from "../../types";
export function PhoneAuthError() {
  const $ = _c(2);
  const errorMessage = useAuthFlow().state.errors[AuthMethodId.PHONE];
  if (!errorMessage) {
    return null;
  }
  let t0;
  if ($[0] !== errorMessage) {
    t0 = <p className="text-center text-body text-status-error-text" role="alert" aria-live="polite">{errorMessage}</p>;
    $[0] = errorMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}